export const INCIDENT = 'incident';
export const NO_BONUS_WHEEL_TUTORIAL = 'NO_BONUS_WHEEL_TUTORIAL';
export const BONUS_WHEEL_TUTORIAL_DISPLAYS = 'BONUS_WHEEL_TUTORIAL_DISPLAYS';
